import { useRef, useState, useLayoutEffect } from 'react';

export const useParallax = (transformAmount: number, delay: number = 0) => {
    const [transformX, setTransformX] = useState(0);
    const [transformY, setTransformY] = useState(0);
    const [isParallaxActive, setIsParallaxActive] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const panelRef = useRef<HTMLDivElement>(null);
    const subpanelRef = useRef<HTMLDivElement>(null);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useLayoutEffect(() => {
        if (panelRef.current && subpanelRef.current) {
            const panelElement = panelRef.current;
            const subpanelElement = subpanelRef.current;

            const handleMouseMove = (mouseEvent: MouseEvent) => {
                // Параллакс работает только если активирован
                if (!isParallaxActive) {
                    return;
                }

                const { clientX: mouseX, clientY: mouseY } = mouseEvent;
                const { left: centerX, top: centerY, width, height } = panelElement.getBoundingClientRect();

                const percentX = (mouseX - (centerX + width / 2)) / (width / 2);
                const percentY = -((mouseY - (centerY + height / 2)) / (height / 2));

                setTransformX(percentX * transformAmount);
                setTransformY(percentY * transformAmount);
            };

            const handleMouseEnter = () => {
                setIsHovered(true);
                // Устанавливаем transition для padding сразу
                subpanelElement.style.transition = 'padding 0.3s easy-in-out';

                // Запускаем параллакс с задержкой
                timeoutRef.current = setTimeout(() => {
                    setIsParallaxActive(true);
                    subpanelElement.style.transition = 'padding 0.3s easy-in-out, transform 0.1s';
                }, delay);
            };

            const handleMouseLeave = () => {
                setIsHovered(false);
                // Отменяем таймер если мышь ушла до активации параллакса
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }

                setIsParallaxActive(false);
                subpanelElement.style.transition = 'padding 0.3s easy-in-out, transform 0.1s';
                // subpanelElement.style.transition = 'padding 0.6s easy-in-out';

                setTimeout(() => {
                    // subpanelElement.style.transition = 'padding 0.6s easy-in-out';
                    subpanelElement.style.transition = 'padding 0.3s easy-in-out';
                }, 100);

                setTransformX(0);
                setTransformY(0);
            };

            panelElement.addEventListener('mousemove', handleMouseMove);
            panelElement.addEventListener('mouseenter', handleMouseEnter);
            panelElement.addEventListener('mouseleave', handleMouseLeave);

            return () => {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                panelElement.removeEventListener('mousemove', handleMouseMove);
                panelElement.removeEventListener('mouseenter', handleMouseEnter);
                panelElement.removeEventListener('mouseleave', handleMouseLeave);
            };
        }
    }, [transformAmount, delay, isParallaxActive]);

    return {
        panelRef,
        subpanelRef,
        transformX,
        transformY,
        isHovered,
    };
};
